import Vue from 'vue'
import 'bootstrap'
import App from './App.vue'
import router from './router'
import ElementUI  from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts';
import MathJax from '@/globalVariable'
import locale from 'element-ui/lib/locale/lang/en'
Vue.prototype.MathJax = MathJax
Vue.prototype.$echarts = echarts;


Vue.use(ElementUI,{locale})
Vue.config.productionTip = false
// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


